export default "__VITE_ASSET__D9$iTGV3__"